import { useState } from "react";
import { useFindAllTargetListQuery } from "../../../../features/targetlistApi";
import { Preferences } from "../../../lib/preferences";
import { PreferencesSection } from "../../../lib/preferences/dto";
import { Layout } from "../../../ui/layout";
import { Spinner } from "../../../ui/molecules/spinner";
import { MenuItems } from "../../../ui/organisms/navbar/dto";
import { NotFound } from "../../../ui/organisms/notFound";
import { FindAllTargetListsFilters } from "../dto";
import { TargetListsFilters } from "./filters";
import { TargetListsList } from "./list";

export function TargetLists() {
  const [filters, setFilters] = useState<FindAllTargetListsFilters>(
    {
      commercial: [],
      contacts: "",
      itemsPerPage: 50,
      name: "",
      order: true,
      page: 0,
      sort: "name",
      state: [],
      teamLeader: [],
      project: [],
      sector: [],
      category: []
    }
  )
  const { data, isLoading } = useFindAllTargetListQuery(filters);

  const targetLists = data?.targetLists;
  const commercials = data?.commercials;
  const teamLeaders = data?.teamLeaders;

  if (isLoading) {
    return <div className="flex items-center justify-center h-screen w-full"><Spinner /></div>
  }

  return (
    <Layout
      menuItem={MenuItems.TARGET_LIST}
      breadcrumbItems={["Liste Target"]}
      headerLabel="Liste Target"
    >
      <div className="p-4 h-full max-h-full">
        <div className="flex flex-col bg-white rounded-2xl shadow-sm h-full max-h-full">
          <TargetListsFilters filters={filters} setFilters={(f) => setFilters({ ...filters, ...f, page: 0 })} />
          {
            targetLists?.total === 0 ||
              !data?.targetLists ? (
              <div style={{ height: 'calc(100% - 128px)' }}>
                <NotFound />
              </div>
            ) : (
              <TargetListsList
                targetLists={targetLists!}
                commercials={commercials!}
                teamLeaders={teamLeaders!}
                filters={filters}
                setFilters={(f) => setFilters({ ...filters, ...f })}
                setItemsPerPage={(itemsPerPage) => setFilters({ ...filters, itemsPerPage, page: 0 })}
                setPage={(page) => setFilters({ ...filters, page })}
              />
            )
          }
        </div>
      </div>
      <Preferences section={PreferencesSection.targetListPreferences} key={PreferencesSection.targetListPreferences} />
    </Layout>
  );
}
